module.exports = __webpack_public_path__ + "static/media/BarberSq.7839803b.jpg";